import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { SLICER_KEYS } from 'types/services';
import type { AuthState } from 'types';

const initialState: AuthState = {
  refreshToken: null,
  tokenProvider: null,
  jwtToken: null,
  apiKey: null,
};

export const authSlice = createSlice({
  name: SLICER_KEYS.AUTH,
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<AuthState>) => {
      state.refreshToken = `Bearer ${action.payload.refreshToken}`;
      state.tokenProvider = action.payload.tokenProvider;
      state.jwtToken = action.payload.jwtToken;
      state.apiKey = action.payload.apiKey;
    },
    setApiKey: (state, action: PayloadAction<string>) => {
      state.apiKey = action.payload;
    },
  },
});

export const { setAuth, setApiKey } = authSlice.actions;
